import { gql } from 'graphql.macro'

export default gql`
  fragment LocationFragment on Location {
    x
    y
  }
`
